angular.module("app").constant("settings", {
    apiURL: "./"
});